const styles= (theme) => {
    return {
        title2: {
            fontSize: '24px !important',
            lineHeight: '28px !important',
            fontStyle: 'normal',
            color: '#1E293B !important'
        },
        button: {
            padding: '12px 24px !important',
            borderRadius: '8px !important'
        },
        buttonLabel: {
            fontSize: '14px !important',
            lineHeight: '16px !important',
            fontStyle: 'normal !important',
            letterSpacing: '0.05em !important'
        }
    }
}

export default styles;
